<template>
  <!-- Ticket data -->

  <div class="flex flex-wrap white-bg full-height relative">
    <!-- Side colored tag -->
    <div
      v-if="billet.blocked"
      class="flex absolute full-height col-12 z5 border-box"
    >
      <div
        class="absolute flex black-bg full-height col-12 border-box dim"
      ></div>
      <BlockedTicket :billet="billet" class="xs-hide mx4 my2" />
      <BlockedTicket :billet="billet" class="lg-hide md-hide sm-hide my4 mx2" />
    </div>
    <div
      v-if="billet.contremarque || billet.order_contremarque"
      class="flex items-center px2 py1 greener-bg"
    >
      <div class="center relative">
        <span class="h7n caps right white bold absolute ticket-type"
          >contremarque</span
        >
      </div>
    </div>
    <div v-else class="flex items-center px2 py1 light-blue-bg">
      <div class="center relative">
        <span class="h7n caps right white bold absolute ticket-type"
          >e-billet</span
        >
      </div>
    </div>

    <div class="flex flex-wrap flex-auto no-box ticket-info">
      <ticket-data :billet="billet" />
      <ticket-qr-code :billet="billet" />
      <ticket-sessions
        :billet="billet"
        :extraId="'mobile'"
        class="lg-hide sm-hide"
      />
    </div>
  </div>
</template>

<script>
import BlockedTicket from "@/components/billets/BlockedTicket";
import TicketData from "./TicketItemData.vue";
import TicketQrCode from "./TicketQRCode.vue";
import TicketSessions from "./TicketSessions.vue";

export default {
  components: { BlockedTicket, TicketData, TicketQrCode, TicketSessions },
  props: {
    billet: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-reserve {
  box-sizing: border-box;
  border: 1px solid black;
  -webkit-transition: color 0.2s, background 0.2s;
  -moz-transition: color 0.2s, background 0.2s;
  -o-transition: color 0.2s, background 0.2s;
  transition: color 0.2s ease-out, background 0.2s ease-out;
  &:hover {
    background: white;
    color: black;
  }
}

// * {
//   border: solid 1px red;
// }
</style>
